import { ConfirmDialog } from "../shared/ConfirmDialog";

export const EliminarBannerDialog = ({ visible, onCancel, onConfirm }) => (
    <ConfirmDialog visible={visible} onCancel={onCancel} onConfirm={onConfirm} header="Eliminar Banner" message="¿Realmente desea eliminar el Banner?" />
);